// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wK2vW","comment":"styles_comment__1_oxm"};